import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueTippy from "vue-tippy";
import vClickOutside from 'v-click-outside'


import 'materialize-css/dist/css/materialize.min.css'
import '@/assets/sass/app.scss'
import json from './_results.json'


Vue.config.productionTip = false

Vue.prototype.globalData = json;


Vue.use(vClickOutside);
Vue.use(VueTippy);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
